import { Observable } from 'rxjs/Observable'

import { TestExecutionService } from '../../../data/services'
import { TestExecution, TestExecutionResult, TaskTypes } from '../../../data/models'
import { Utils } from '../../..'
import { ModuleState } from './'

const PROVE_IT_PASSING_THRESHOLD = 70

export class ModuleStateService {

  public constructor(
    private _testExecutionService: TestExecutionService,
    private _utils: Utils
  ) {}

  // TODO [GitHub Issue]: https://github.com/ManhattanPrep/js-libs/issues/86 (Add Syllabus Models)
  public forUnit(unit): Observable<{[sectionId: string]: ModuleState}> {
    return this._getTestStates(unit).map((moduleStates) => Object.assign(this._getStateByTaskCompletion(unit), moduleStates))
  }

  private _getStateByTaskCompletion(unit) {
    return unit.pathNodes.reduce((moduleStatesBySection, section) => {
      const learnItTask = section.tasks.find((task) => task.taskType === TaskTypes.LearnIt)
      if (learnItTask) {
        moduleStatesBySection[section.id] = this._determineStateFromTask(learnItTask)
      }
      return moduleStatesBySection
    }, {})
  }

  private _getTestStates(unit): Observable<{[sectionId: string]: ModuleState}> {
    const testIdsHash = this._getTestIds(unit)
    const testIds = Object.values(testIdsHash)
    const executionsForTests = this._getExecutionObservable(testIds)
    return this._getTestModuleStateObservable(executionsForTests, testIdsHash)
  }

  private _getTestIds(unit): { [sectionId: string]: string } {
    return unit.pathNodes.reduce((testIdBySection, section) => {
      const proveItTask = section.tasks.find((task) => task.taskType === TaskTypes.ProveIt)
      if (proveItTask) {
        const examUrl = proveItTask.resource.uri
        const testId = this._getTestItIdFromResourceUrl(examUrl)
        if (this._isNumber(testId)) {
          testIdBySection[section.id] = this._getTestItIdFromResourceUrl(examUrl)
        }
      }
      return testIdBySection
    }, {})
  }

  private _getExecutionObservable(testIds: string[]): Observable<TestExecution[]> {
    return this._testExecutionService.findLatestByTestIds(testIds, {status: ['finished', 'aborted']})
  }

  private _getTestModuleStateObservable(executionsForTests: Observable<TestExecution[]>, testIdsHash: {}) {
    return executionsForTests.map((testExecutions: TestExecution[]) => {
      return testExecutions.reduce((moduleStatesById, testExecution) => {
        const sectionId = this._utils.getKeyByValue(testIdsHash, testExecution.test.id)
        moduleStatesById[sectionId] = this._determinetateFromExecution(testExecution)
        return moduleStatesById
      }, {})
    })
  }

  private _determinetateFromExecution(testExecution: TestExecution): ModuleState {
    const result = testExecution.testExecutionResults || [new TestExecutionResult()]
    const incomplete = testExecution.isIncomplete
    const sectionCorrectness = result[0].normalizedPercentCorrect

    if (incomplete) {
      return ModuleState.InProgress
    } else if (sectionCorrectness >= PROVE_IT_PASSING_THRESHOLD) {
      return ModuleState.Proficient
    } else {
      return ModuleState.Failed
    }
  }

  private _getTestItIdFromResourceUrl(resourceUrl: string) {
    return resourceUrl.split('/').pop()
  }

  private _determineStateFromTask(task): ModuleState {
    const userTask = task.userTask || {}
    if (userTask.isFinished) {
      return ModuleState.Proficient
    } else if (userTask.isIncomplete) {
      return ModuleState.InProgress
    }
  }

  private _isNumber(id: string): boolean {
    const allDigitRegexp = /^\d+$/
    return id.match(allDigitRegexp) !== null
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/core/services/module-state/module-state.service.ts